import type { EnteringFund } from '../../types/finance';
import { readerLocale } from '../../i18n/language';

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

/** A CALENDAR date (`yyyy-mm-dd`) shown as itself. `new Date('2026-11-02')` is UTC
 *  midnight, which a viewer west of Greenwich would read as 1 November - and the day a
 *  client's money starts counting is not something to be off by one on. */
export function calendarDate(day: string): string {
  const parts = DATE_ONLY.exec(day);
  if (!parts) return day;
  const utc = new Date(Date.UTC(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3])));
  return utc.toLocaleDateString(readerLocale(), {
    year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC',
  });
}

/** What the client is told about one deposit that has not entered its fund yet. Money that
 *  is waiting for a place carries no date and no figure: nothing is promised about it. */
export function enteringFundLine(row: EnteringFund): string {
  if (row.awaiting_allocation) return 'Received — awaiting allocation';
  return row.enters_on
    ? `Starts on ${calendarDate(row.enters_on)}. Your term starts on that date.`
    : 'Received. We are confirming the date it starts.';
}
